import { OperationVariables, gql } from "@apollo/client";
import { IEmployeeCoverage, MaybeSkill } from "@sharedInterfaces/IOpportunity";
import { IReference } from "@sharedInterfaces/IReference";

import GraphQL from "../graphQL";

import { employeeCoverageGql } from "./getOpportunity";


const query = gql`
query($skills:[OpportunitySkillInput!]!, $certificates:[OpportunityCertificateInput!]!, $roles:[OpportunityRoleInput!]) {
    getSuggestedEmployees(skills: $skills, certificates: $certificates, roles: $roles) 
    ${employeeCoverageGql}
},
`;

/**
 * Retrieves a list of suggested employees based on the provided skills.
 * 
 * @param {Array<object>} skills - Array of skills used for suggesting employees.
 * @returns {Promise<Array<object>>} - A promise that resolves to an array of suggested employees with their corresponding skill coverage.
 */
export default async function getSuggestedEmployees(skills: MaybeSkill[], certificates: IReference[], roles?: IReference[]): Promise<IEmployeeCoverage[]>
{
    const variables: OperationVariables = {
        skills,
        certificates,
        roles
    };
    return GraphQL.query<{ getSuggestedEmployees: IEmployeeCoverage[] }>(query, variables)
        .then(result => result.getSuggestedEmployees)
}